/**
 * ohygia-combo-bundle.js
 * ──────────────────────────────────────────────────────────────────────────
 * Controls the O'hygia combo upsell widget on the PDP.
 *
 * Default state  : only the cup is "selected", sterilizer unchecked,
 *                  button reads "Add to Cart" and delegates to the native form.
 * Combo state    : sterilizer checked → button reads "Add Combo to Cart"
 *                  and POSTs all three items via /cart/add.js.
 *
 * All button/label text is read from data-* attributes set by combo-bundle.liquid,
 * which in turn reads from section.settings.* so everything is editable in the
 * Shopify Theme Customizer.
 * ──────────────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  /* ── Selector map ──────────────────────────────────────────────────── */
  var SELECTORS = {
    bundle:        '#ohygia-combo-bundle',
    variantInput:  '[name="id"]',
    checkbox:      '#ohygia-add-sterilizer',
    freeGift:      '#ohygia-free-gift',
    bundleFooter:  '#ohygia-bundle-footer',
    cupPrice:      '#ohygia-cup-price',
    bundleTotal:   '#ohygia-bundle-total',
    savingsMsg:    '#ohygia-savings-msg',
    btn:           '#ohygia-bundle-btn',
    msg:           '#ohygia-msg',
  };

  /* ── Module state ──────────────────────────────────────────────────── */
  var bundleEl, checkboxEl, freeGiftEl, bundleFooterEl,
      cupPriceEl, bundleTotalEl, savingsMsgEl, btnEl, msgEl;

  var sterilizerPrice     = 0;
  var freePrice           = 0;
  var sterilizerVariantId = 0;
  var freeVariantId       = 0;
  var btnSingleText       = 'Add to Cart';
  var btnComboText        = 'Add Combo to Cart';
  var savingsPrefix       = 'You save';
  var savingsSuffix       = 'on Cup Wash!';
  var msgTimer            = null;

  /* ── Helpers ───────────────────────────────────────────────────────── */

  function formatMoney(cents) {
    var rupees = Math.round(cents / 100);
    return '₹' + rupees.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function getSelectedVariantId() {
    var input = document.querySelector(SELECTORS.variantInput);
    if (!input || !input.value) return null;
    var id = parseInt(input.value, 10);
    return isNaN(id) ? null : id;
  }

  function getCupPrice() {
    var scriptEl = document.querySelector('[data-product-json]') ||
                   document.querySelector('script[id^="ProductJson-"]');
    if (!scriptEl) return 0;
    try {
      var data     = JSON.parse(scriptEl.textContent);
      var variants = Array.isArray(data) ? data : (data.variants || []);
      var selectedId = getSelectedVariantId();
      if (selectedId === null) return 0;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === selectedId) return variants[i].price;
      }
      return 0;
    } catch (e) {
      return 0;
    }
  }

  /* ── Price display ─────────────────────────────────────────────────── */

  function updatePrices() {
    var cupPrice = getCupPrice();
    var isCombo  = checkboxEl && checkboxEl.checked;

    if (cupPriceEl) {
      cupPriceEl.textContent = formatMoney(cupPrice);
    }

    if (bundleTotalEl) {
      bundleTotalEl.textContent = formatMoney(cupPrice + sterilizerPrice);
    }

    if (savingsMsgEl) {
      if (isCombo && freePrice > 0) {
        savingsMsgEl.textContent = '🎉 ' + savingsPrefix + ' ' +
                                   formatMoney(freePrice) + ' ' + savingsSuffix;
        savingsMsgEl.style.display = 'block';
      } else {
        savingsMsgEl.style.display = 'none';
      }
    }
  }

  /* ── Toggle — runs on every checkbox change and on init ────────────── */

  function toggleBundle() {
    var isCombo = checkboxEl && checkboxEl.checked;

    /* Free gift row */
    if (freeGiftEl) {
      if (isCombo) {
        freeGiftEl.classList.add('ohygia-combo__free--visible');
        freeGiftEl.setAttribute('aria-hidden', 'false');
      } else {
        freeGiftEl.classList.remove('ohygia-combo__free--visible');
        freeGiftEl.setAttribute('aria-hidden', 'true');
      }
    }

    /* Bundle total footer */
    if (bundleFooterEl) {
      bundleFooterEl.style.display = isCombo ? '' : 'none';
    }

    /* Button text */
    if (btnEl) {
      btnEl.textContent = isCombo ? btnComboText : btnSingleText;
    }

    updatePrices();
  }

  /* ── Status messages ───────────────────────────────────────────────── */

  function showMsg(text, type) {
    if (!msgEl) return;
    clearTimeout(msgTimer);
    msgEl.textContent   = text;
    msgEl.className     = 'ohygia-combo__msg ohygia-combo__msg--' + type;
    msgEl.style.display = 'block';
    if (type === 'success') {
      msgTimer = setTimeout(function () { msgEl.style.display = 'none'; }, 4000);
    }
  }

  /* ── Native form trigger (single-product path) ─────────────────────── */

  function triggerNativeAdd() {
    /* Clicking the hidden submit button lets Shopify's product-form.js
       handle the cart drawer, error states, and loading animation. */
    var nativeSubmit = document.querySelector('button[name="add"]');
    if (nativeSubmit) {
      nativeSubmit.click();
      return;
    }
    /* Fallback: submit the form directly */
    var nativeForm = document.querySelector('[data-type="add-to-cart-form"]');
    if (nativeForm) {
      if (typeof nativeForm.requestSubmit === 'function') {
        nativeForm.requestSubmit();
      } else {
        nativeForm.submit();
      }
    }
  }

  /* ── AJAX combo add ────────────────────────────────────────────────── */

  function addComboToCart(items) {
    if (!btnEl) return;

    var originalText  = btnEl.textContent;
    btnEl.disabled    = true;
    btnEl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: {
        'Content-Type':     'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Could not add to cart.');
          });
        }
        return res.json();
      })
      .then(function (data) {
        var itemKey = data.items && data.items[0] ? data.items[0].key : '';

        var cart = document.querySelector('cart-notification') ||
                   document.querySelector('cart-drawer');

        if (!cart || typeof cart.renderContents !== 'function') {
          window.location.reload();
          return;
        }

        var sectionIds = cart.getSectionsToRender
          ? cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
          : 'cart-notification-product,cart-notification-button,cart-icon-bubble';

        return fetch(
          window.location.pathname + '?sections=' + encodeURIComponent(sectionIds),
          { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
        )
          .then(function (res) { return res.json(); })
          .then(function (sections) {
            cart.renderContents({ key: itemKey, sections: sections });
            btnEl.textContent = originalText;
            btnEl.disabled    = false;
          });
      })
      .catch(function (err) {
        showMsg(err.message || 'Something went wrong. Please try again.', 'error');
        btnEl.textContent = originalText;
        btnEl.disabled    = false;
      });
  }

  /* ── Button click handler ──────────────────────────────────────────── */

  function handleBtnClick(e) {
    e.preventDefault();

    var isCombo = checkboxEl && checkboxEl.checked;

    if (!isCombo) {
      /* Default path — delegate entirely to the native Shopify product form */
      triggerNativeAdd();
      return;
    }

    /* Combo path — AJAX add: cup + sterilizer + free gift */
    var cupVariantId = getSelectedVariantId();
    if (!cupVariantId) {
      showMsg('Please select a size first.', 'error');
      return;
    }

    var items = [{ id: cupVariantId, quantity: 1 }];
    if (sterilizerVariantId) items.push({ id: sterilizerVariantId, quantity: 1 });
    if (freeVariantId)       items.push({ id: freeVariantId,       quantity: 1 });

    addComboToCart(items);
  }

  /* ── Variant change listeners ──────────────────────────────────────── */

  function listenVariantChange() {
    /* Dawn pub/sub — most reliable for this theme */
    if (typeof subscribe === 'function') {
      subscribe('variant-change', updatePrices);
    }

    /* Generic custom events from other themes / apps */
    document.addEventListener('variant:change',  updatePrices);
    document.addEventListener('variantSelected', updatePrices);

    /* Direct listener + MutationObserver on the hidden variant input */
    var variantInput = document.querySelector(SELECTORS.variantInput);
    if (variantInput) {
      variantInput.addEventListener('change', updatePrices);
      new MutationObserver(updatePrices).observe(variantInput, {
        attributes:      true,
        attributeFilter: ['value'],
      });
    }
  }

  /* ── Init ──────────────────────────────────────────────────────────── */

  function init() {
    bundleEl = document.querySelector(SELECTORS.bundle);
    if (!bundleEl) return; /* metafields not set — snippet did not render */

    /* Read prices and IDs from data attributes set by the Liquid snippet */
    sterilizerVariantId = parseInt(bundleEl.dataset.sterilizerId,    10) || 0;
    sterilizerPrice     = parseInt(bundleEl.dataset.sterilizerPrice,  10) || 0;
    freeVariantId       = parseInt(bundleEl.dataset.freeId,           10) || 0;
    freePrice           = parseInt(bundleEl.dataset.freePrice,        10) || 0;

    /* Text sourced from section.settings via data attributes */
    btnSingleText = bundleEl.dataset.btnSingle    || 'Add to Cart';
    btnComboText  = bundleEl.dataset.btnCombo     || 'Add Combo to Cart';
    savingsPrefix = bundleEl.dataset.savingsPrefix || 'You save';
    savingsSuffix = bundleEl.dataset.savingsSuffix || 'on Cup Wash!';

    /* Query UI elements */
    checkboxEl     = bundleEl.querySelector(SELECTORS.checkbox);
    freeGiftEl     = bundleEl.querySelector(SELECTORS.freeGift);
    bundleFooterEl = bundleEl.querySelector(SELECTORS.bundleFooter);
    cupPriceEl     = bundleEl.querySelector(SELECTORS.cupPrice);
    bundleTotalEl  = bundleEl.querySelector(SELECTORS.bundleTotal);
    savingsMsgEl   = bundleEl.querySelector(SELECTORS.savingsMsg);
    btnEl          = bundleEl.querySelector(SELECTORS.btn);
    msgEl          = bundleEl.querySelector(SELECTORS.msg);

    /* Bind events */
    if (checkboxEl) checkboxEl.addEventListener('change', toggleBundle);
    if (btnEl)      btnEl.addEventListener('click', handleBtnClick);

    listenVariantChange();

    /* Set initial UI state — checkbox is unchecked, so this hides free gift
       and shows the single-product button text. */
    toggleBundle();
  }

  /* ── Bootstrap ─────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
